<template>
  <div id="about-section">
    <div class="row vision-row justify-content-center container-fluid">
      <div class="col-md-3">
        <h1 class="center-head">What is FleetREDI?</h1>
          <div class="fleet-redi-logo">
            <img src="@/assets/images/FleetREDI-logo.png" alt="FleetREDI">
          </div>
        </div>
      <div class="col-md-7">
        <p class="about-p-tag">A secure, online, national resource where government and industry partners can find (and provide) data to answer pressing commercial vehicle research questions.</p>
        <p class="about-p-tag">FleetREDI ultimately supports the development of medium- and heavy-duty vehicle technologies and aims to help researchers, manufacturers, and fleet owners find solutions that meet goals for reducing energy consumption, greenhouse gas emissions, and costs.</p>
        <div class="eere-logo-container">
          <div class="eere-logo-text">
            <p class="about-p-tag">FleetREDI is powered by researchers from the U.S. Department of Energy's National Laboratory of the Rockies (NLR). Learn more about NLR's <a href="https://www.nlr.gov/transportation/">transportation and mobility research</a>.</p>
            <p class="about-p-tag">FleetREDI was developed with funding from the U.S. Department of Energy's Office of Critical Minerals and Energy Innovation.</p>
          </div>
        </div>
        <div class="vision-btns">
          <router-link to="/dashboard" class="vision-btn text-decoration-none">See the data</router-link>
          <router-link to="/action-plan" class="vision-btn text-decoration-none">Read our action plan</router-link>
        </div>
      </div>
    </div>
    <div class="row goal-row container-fluid justify-content-center">
      <h4>Our goal is to support efforts to reduce future truck energy use, emissions, and total cost of ownership by: </h4>
      <div class="box-row">
        <div class="goal-box">
          <div class="icon-holder">
            <div class="goal-circle">
              <font-awesome-icon icon="check-circle" class="goal-icon"/>
            </div>
          </div>
          <div class="goal-txt"><p>Filling priority gaps in data sets</p></div>
        </div>
        <div class="goal-box">
          <div class="icon-holder">
            <div class="goal-circle">
              <font-awesome-icon icon="database" class="goal-icon"/>
            </div>
          </div>
          <div class="goal-txt"><p>Expanding operational data to achieve nationally representative coverage</p></div>
        </div>
      </div>
      <div class="box-row">
        <div class="goal-box">
          <div class="icon-holder">
            <div class="goal-circle">
              <font-awesome-icon icon="sitemap" class="goal-icon"/>
            </div>
          </div>
          <div class="goal-txt"><p>Establishing methodologies to enable data fusion</p></div>
        </div>
        <div class="goal-box">
          <div class="icon-holder">
            <div class="goal-circle">
              <font-awesome-icon icon="road" class="goal-icon"/>
            </div>
          </div>
          <div class="goal-txt"><p>Collecting comprehensive supplemental data on physical infrastructure and climate</p></div>
        </div>
      </div>
      <div class="box-row">
        <div class="goal-box">
          <div class="icon-holder">
            <div class="goal-circle">
              <font-awesome-icon icon="chart-pie" class="goal-icon"/>
            </div>
          </div>
          <div class="goal-txt"><p>Providing key data and analysis to inform and enable research and development</p></div>
        </div>
        <div class="goal-box">
          <div class="icon-holder">
            <div class="goal-circle">
              <font-awesome-icon icon="key" class="goal-icon"/>
            </div>
          </div>
          <div class="goal-txt"><p>Enabling Department of Energy, laboratory, and stakeholder access to data and analytical results</p></div>
        </div>
      </div>
    </div>
    <CitationNote />
  </div>
</template>

<script setup>
import CitationNote from '@/components/CitationNote.vue';
</script>
